module.exports = "pegasus/assets/theme6/header-image.jpg";